import {Injectable}   from '@angular/core';
import {MoodTermType} from '@djsharkk/logr-types';

@Injectable({
				providedIn: 'root'
			})
export class MenuCrudPanelMoodService {
	selected: MoodTermType[] = [];

	constructor() {
	}

}
